export default "__VITE_ASSET__DqLt3iYI__"